import {
  ICON_INDEX_PREFIX,
  initialCustomWptsFile,
  strcuturePoiIcon,
} from "../../GPX/Resources";
import { sendFileToPhone, createBlob } from "./SendFilesToPhone";
import { removeHtmlTags, getDistanceValue } from "../../../util/Util";
import { projectFilesApi } from "../../../../api/projectFiles";
import DialogBox from "../../../util/DialogBox";
import axios from "axios";
import { LoadingBoxWithProgressBar } from "../../../util/LoadingBox";
import { generateGPXEMLFile } from "./GpxTemplates";

/**
 * Traduit les instructions de navigation en français
 * @param {string} maneuver - Manoeuvre de navigation
 * @param {string} instructions - Instructions de navigation
 * @returns {object} translations - Traductions des instructions de navigation
 */
export const translateManeuver = (maneuver, instructions) => {
  const getRoundaboutExitText = (string) => {
    const match = string.match(/\d+/);
    if (match && match[0]) {
      // Vérifier si match renvoie une valeur non nulle
      const exitNumber = parseInt(match[0]);
      if (exitNumber == 1) return "1ère Sortie";
      else if (exitNumber > 1 && exitNumber < 6)
        return exitNumber + "ème Sortie";
      else return "";
    }
  };
  const translations = {
    "turn-right": "Droite",
    "turn-left": "Gauche",
    straight: "Tout droit",
    "turn-slight-right": "Légèrement à droite",
    "turn-slight-left": "Légèrement à gauche",
    "turn-sharp-right": "Tourner carément à droite",
    "turn-sharp-left": "Tourner carément à gauche",
    "roundabout-right": () => {
      return getRoundaboutExitText(instructions);
    },
    "roundabout-left": () => {
      return getRoundaboutExitText(instructions);
    },
    "keep-right": "Restez à droite",
    "keep-left": "Restez à gauche",
    Audio: "Audio",
  };
  return translations[maneuver]
    ? typeof translations[maneuver] === "function"
      ? translations[maneuver]()
      : translations[maneuver]
    : "";
};

const subTypeNumber = (subType) => {
  const typeNumbers = {
    Info1: "10003",
    Info2: "10004",
    Info3: "10016",
    Panorama1: "10005",
    Panorama2: "10006",
    Panorama3: "10017",
    Repas1: "10007",
    Repas2: "10008",
    Toilettes1: "10011",
    Toilettes2: "10012",
    Toilettes3: "10019",
    Parking: "10013",
    Parking3: "10020",
    Recharge: "10014",
    Recharge3: "10021",
  };
  return typeNumbers[subType] || null;
};

export const trkType = (parcoursType) => {
  const typeColors = {
    Voiture: "#0000FF",
    Rando: "#00AE00",
    "Retour rapide": "#D152D7",
    Velo: "#FF5733",
  };
  return typeColors[parcoursType] || null;
};

const iconNumber = (type) => {
  const iconNumbers = {
    Audio: "10000",
    Gauche: "1000",
    Droite: "1001",
    "Tout droit": "1002",
    Retour: "1003",
    "Déviation à droite": "1004",
    "Déviation à gauche": "1005",
    "Continuer vers la droite": "1006",
    "Continuer vers la gauche": "1007",
    "Continuer tout droit": "1008",
    "1ère Sortie": "1009",
    "2ème Sortie": "1010",
    "3ème Sortie": "1011",
    "4ème Sortie": "1012",
    "5ème Sortie": "1013",
    "Restez à droite": "1014",
    "Restez à gauche": "1015",
    "Légèrement à droite": "1016",
    "Légèrement à gauche": "1017",
    "Tourner carrément à droite": "1018",
    "Tourner carrément à gauche": "1019",
    Info1: "10003",
    Info2: "10004",
  };
  return iconNumbers[type] || null;
};
/**
 * Envoie le fichier GPX à la tablette via la fonction sendFileToPhone
 * @param {string} GPXFile - Fichier GPX
 * @param {string} projectName - Nom du projet
 * @param {string} projectId - Identifiant du projet propriétaire
 */
const sendGPX = (GPXFile, projectName, projectId, sendToPhone) => {
  const blobGPX = new Blob([GPXFile], { type: "application/gpx+xml" });
  return sendFileToPhone(
    blobGPX,
    projectName + ".gpx",
    projectFilesApi.upload(projectId, "gpx", { toTablet: sendToPhone }),
    "GPX"
  );
};

/**
 * Permet d'envoyer le fichier TXT à la tablette via la fonction sendFileToPhone
 * @param {string} customWptsFile - fichier des points de navigation customisés
 * @param {string} projectId - Identifiant du projet propriétaire
 */
const sendTxt = (customWptsFile, projectId, sendToPhone) => {
  const blobTxt = new Blob([customWptsFile], { type: "text/plain" });
  return sendFileToPhone(
    blobTxt,
    "customwpts.txt",
    projectFilesApi.upload(projectId, "txt", { toTablet: sendToPhone }),
    "TXT"
  );
};

/**
 * Permet d'envoyer les icones des markers à la tablette via la fonction sendFileToPhone
 * @param {array} markers - Tableau des markers
 * @param {string} projectId - Identifiant du projet propriétaire
 * @param {array} markerTypes - Tableau des types de markers
 */
const sendImages = (markers, projectId, markerTypes, sendToPhone) => {
  const transfers = [];

  markers.forEach((marker) => {
    if (marker.markerToDownload) {
      transfers.push(
        (async () => {
          const iconBlob = await createBlob(marker.markerToDownload);
          if (marker.markerToDownload.length > 0) {
            return sendFileToPhone(
              iconBlob,
              marker.iconName + ".png",
              projectFilesApi.upload(projectId, "icon", { toTablet: sendToPhone }),
              "icon"
            );
          }
        })()
      );
    }
  });

  //Utilisation pour l'envoie des images marker touristic
  markers.forEach((marker) => {
    if (marker.type === markerTypes.touristic && marker.image) {
      if (Array.isArray(marker.imageName)) {
        marker.imageName.forEach((imageName, index) => {
          transfers.push(
            (async () => {
              const imageBlob = await createBlob(marker.image[index]);
              if (imageName.length > 0) {
                return sendFileToPhone(
                  imageBlob,
                  imageName,
                  projectFilesApi.upload(projectId, "image", { toTablet: sendToPhone }),
                  "image"
                );
              }
            })()
          );
        });
      }
    }
  });

  markers.forEach((marker) => {
    if (marker.audio) {
      if (Array.isArray(marker.audioName)) {
        marker.audioName.forEach((audioName, index) => {
          transfers.push(
            (async () => {
              const audioBlob = await createBlob(marker.audio[index]);
              if (audioName.length > 0) {
                return sendFileToPhone(
                  audioBlob,
                  audioName,
                  projectFilesApi.upload(projectId, "audio", { toTablet: sendToPhone }),
                  "audio"
                );
              }
            })()
          );
        });
      }
    }
  });

  markers.forEach((marker) => {
    if (marker.video) {
      if (Array.isArray(marker.videoName)) {
        marker.videoName.forEach((videoName, index) => {
          transfers.push(
            (async () => {
              const videoBlob = await createBlob(marker.video[index]);
              if (videoName.length > 0) {
                return sendFileToPhone(
                  videoBlob,
                  videoName,
                  projectFilesApi.upload(projectId, "video", { toTablet: sendToPhone }),
                  "video"
                );
              }
            })()
          );
        });
      }
    }
  });

  return Promise.all(transfers);
};

export const CompileProject = async (
  projectName,
  customNavigationPoints,
  markers,
  markerTypes,
  originMarker,
  destinationMarker,
  destinationSameAsOrigin,
  trkseg,
  parcoursType,
  iconIndexArray,
  coordinates,
  sendToDevice,
  sendFileToServer,
  projectId
) => {
  var customWptsFile = initialCustomWptsFile;
  var formattedIndexArray = iconIndexArray
    .map(function (valeur) {
      return valeur + "\n";
    })
    .join("");
  customWptsFile += formattedIndexArray;

  /**
   * Télécharge toutes les icônes des markers
   */
  const downloadAllMarkersIcons = () => {
    markers.forEach((marker) => {
      if (marker.markerToDownload) {
        const link = document.createElement("a");
        link.download = marker.iconName + ".png";
        link.href = marker.markerToDownload;
        link.click();
      }
    });
  };

  /**
   * Télécharge un fichier texte
   * @param {string} text - Texte à télécharger
   * @param {string} name - Nom du fichier
   */
  const downloadTextFile = (text, name) => {
    const cleanText = text.replaceAll(",", "");
    const blob = new Blob([cleanText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = name;
    link.href = url;
    link.click();
  };

  const frenshTypes = [
    "Gauche",
    "Droite",
    "Tout droit",
    "Retour",
    "Déviation à droite",
    "Déviation à gauche",
    "Continuer vers la droite",
    "Continuer vers la gauche",
    "Continuer tout droit",
    "1ère Sortie",
    "2ème Sortie",
    "3ème Sortie",
    "4ème Sortie",
    "5ème Sortie",
    "Restez à droite",
    "Restez à gauche",
    "Légèrement à droite",
    "Légèrement à gauche",
    "Tourner carément à droite",
    "Tourner carément à gauche",
    "Audio",
  ];

  const GPXFile = generateGPXEMLFile(
    projectName,
    customNavigationPoints,
    markers,
    markerTypes,
    originMarker,
    destinationMarker,
    destinationSameAsOrigin,
    trkseg,
    parcoursType,
    frenshTypes,
    coordinates,
    removeHtmlTags,
    translateManeuver,
    iconNumber,
    getDistanceValue,
    subTypeNumber,
    ICON_INDEX_PREFIX,
    strcuturePoiIcon,
    trkType
  );

  if (!sendToDevice && !sendFileToServer) {
    downloadTextFile(GPXFile, projectName + ".gpx");
    downloadTextFile(customWptsFile, "customwpts.txt");
    downloadAllMarkersIcons();
  }

  if (!sendToDevice && sendFileToServer) {
    try {
      // Le stockage est immuable : aucun répertoire n'est vidé avant
      // l'écriture des nouvelles clés de contenu.
      await Promise.all([
        sendGPX(GPXFile, projectName, projectId, false),
        sendTxt(customWptsFile, projectId, false),
        sendImages(markers, projectId, markerTypes, false),
      ]);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement du projet :", error);
    }
  }

  if (sendToDevice && !sendFileToServer) {
    // Vérifier la connexion de la tablette
    const checkTabletConnection = () => {
      return axios.get(projectFilesApi.tabletStatus(projectId), {
        withCredentials: true,
      });
    };
    // Effectuer la vérification de la connexion avant d'envoyer les fichiers
    checkTabletConnection()
      .then(async (response) => {
        LoadingBoxWithProgressBar();
        if (response.data.connected) {
          // Utilisation pour envoyer le fichier GPX
          await sendGPX(GPXFile, projectName, projectId, true);
          // Utilisation pour envoyer le fichier TXT
          await sendTxt(customWptsFile, projectId, true);

          //Utilisation pour l'envoie des icons
          await sendImages(markers, projectId, markerTypes, true);
        } else {
          // La tablette n'est pas connectée, affichez un message d'erreur
          DialogBox({
            text: "Veuillez vérifier que le RoadPlayer est connecté et que le mode debugage est activé",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la vérification de la connectivité de la tablette:",
          error
        );
      });
  }
};
